import type { MutableRefObject } from 'react';

/** Tracks form fields being written by observer mapTo (not user input). */
export type ProgrammaticWriteGuardRef = MutableRefObject<Set<string>>;

export function markProgrammaticWrites(
  guard: ProgrammaticWriteGuardRef | undefined,
  fields: string[],
): void {
  if (!guard) return;
  for (const field of fields) {
    guard.current.add(field);
  }
}

/**
 * Release all programmatic marks after the effect processor finishes the current tick.
 * Called from effectProcessor — NOT from observerProcessor (setTimeout(0) there races
 * React's useEffect and the clear effect runs after adjust mapTo writes targetCancelled).
 */
export function releaseProgrammaticWrites(guard: ProgrammaticWriteGuardRef | undefined): void {
  if (!guard) return;
  guard.current.clear();
}

export function isProgrammaticWrite(
  guard: ProgrammaticWriteGuardRef | undefined,
  field: string,
): boolean {
  return guard?.current.has(field) ?? false;
}
